import React from "react";

const PaperAlliedProductsIcon = ({
  color = "#5D5D5D",
  width = "25",
  height = "15",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.3477 3.19279C9.83719 2.6543 10.4742 2.21829 11.207 1.92014C11.9398 1.62199 12.7478 1.47009 13.5653 1.47677H18.7882C19.4727 1.47677 20.1504 1.58762 20.7827 1.80299C21.4151 2.01836 21.9896 2.33403 22.4736 2.73198C22.9576 3.12993 23.3415 3.60237 23.6034 4.12231C23.8654 4.64226 24.0002 5.19954 24.0002 5.76232C24.0002 6.32511 23.8654 6.88238 23.6034 7.40233C23.3415 7.92228 22.9576 8.39471 22.4736 8.79266C21.9896 9.19061 21.4151 9.50628 20.7827 9.72165C20.1504 9.93702 19.4727 10.0479 18.7882 10.0479H13.5653C12.3656 10.0474 11.2028 9.70656 10.2732 9.08295C9.3436 8.45934 8.7041 7.59112 8.46265 6.62482"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5375 8.38008C16.2961 7.41378 15.6566 6.54556 14.727 5.92195C13.7974 5.29834 12.6346 4.95753 11.4348 4.95703H6.21195C4.82966 4.95703 3.50398 5.40854 2.52655 6.21224C1.54911 7.01593 1 8.10598 1 9.24258C1 10.3792 1.54911 11.4692 2.52655 12.2729C3.50398 13.0766 4.82966 13.5281 6.21195 13.5281H11.4348C12.1183 13.5291 12.7953 13.4193 13.4271 13.205C14.0589 12.9908 14.6332 12.6762 15.1171 12.2793C15.2951 12.1365 15.4561 11.9801 15.5978 11.8121"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default PaperAlliedProductsIcon;
